import React from "react";
import { Grid } from "@mui/material";
import { ICredentialsPartnerProps } from "../../interfaces/configuration";
import { SimpleFormInput } from "./SimpleFormInput";

const CredentialsPartner = ({
  values,
  setValues,
  errors,
}: ICredentialsPartnerProps) => {
  const baseInfo = {
    values,
    setValues,
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <SimpleFormInput
          inputTitle="API Token"
          placeholder="Ingresar API Token"
          valueName="api_token"
          errors={errors.api_token}
          {...baseInfo}
          autoFocus
        />
      </Grid>
      <Grid item md={6}>
        <SimpleFormInput
          inputTitle="IVA"
          placeholder={"21"}
          valueName="iva"
          errors={errors.iva}
          endAdornment="%"
          {...baseInfo}
        />
      </Grid>
    </Grid>
  );
};

export default CredentialsPartner;
